<template>
  <b-modal
    :ref="modalRef"
    :id="`deleteCampaignGroupModal`"
    title="Remove Campaigns"
    class="modal-content"
  >
    <p class="my-4">
      This action will remove all campaigns from the Campaign Group.
    </p>
    <p class="my-4">
      Are you sure you want to proceed?
    </p>

    <template #modal-title>
      <i class="fas fa-triangle-exclamation text-warning" />
      Delete Campaigns
    </template>

    <template #modal-footer>
      <b-btn
        class="border-0"
        @click="onCancel"
      >
        Cancel
      </b-btn>
      <b-btn
        variant="primary"
        @click="onConfirm"
      >
        Confirm
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'DeleteCampaignToGroupModal',
  props: {
    advertiserId: {
      type: Number,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      existingCampaignGroupName: '',
      campaignGroupName: '',
    };
  },
  computed: {
    modalRef() {
      return `deleteCampaignGroupModal-${this.id}`;
    },
    isDisabled() {
      return !this.campaignGroupName || (this.campaignGroupName === this.existingCampaignGroupName);
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.DELETE_CAMPAIGN_GROUP,
    ]),
    showModal() {
      this.$refs[this.modalRef].show();
    },
    hideModal() {
      this.$refs[this.modalRef].hide();
    },
    onCancel() {
      this.hideModal();
    },
    onConfirm() {
      const payload = {
        advertiserId: this.advertiserId,
        group: this.group,
      };

      this.DELETE_CAMPAIGN_GROUP(payload)
        .then(() => {
          this.refreshTable();
        });
    },
    refreshTable() {
      this.$emit('refreshTable');
    },
  },
};
</script>
